import React, { useEffect, useRef, useState } from "react";
import axios from "axios";

// /academy/videos/
const Design = () => {
  const [input, setInput] = useState("");
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);

  // تغییر پیام ورودی کاربر
  const handleChange = (e) => {
    setInput(e.target.value);
  };

  // ارسال درخواست به API OpenAI
  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!input.trim()) return;

    const userMessage = input;
    setMessages([...messages, { role: "user", content: userMessage }]);
    setInput("");
    setLoading(true);

    try {
      const response = await axios.post(
        "https://openrouter.ai/api/v1/chat/completions",
        {
          model: "openai/gpt-4o", // انتخاب مدل GPT-4
          messages: [
            {
              role: "system",
              content:
                "تو یک دستیار هوشمند حرفه‌ای هستی که در سایت myunibest.com فعالیت می‌کنی. مأموریت تو کمک به دانش‌آموزان، دانشجویان و داوطلب‌های کنکور و مهاجرت تحصیلیه تا بتونن مسیر تحصیلی، دانشگاه، رشته، و شغل آینده‌شون رو آگاهانه انتخاب کنن. در یونی‌ بست، تمرکز اصلی روی **توسعه فردی**، آگاهی از خود، شناخت توانایی‌ها، علایق و مسیرهای ممکن برای پیشرفت تحصیلی و کاریه. تو باید با لحنی صمیمی، محترمانه و پرانرژی با کاربران صحبت کنی، اما در عین حال اطلاعات دقیق، کاربردی و شفاف بدی. از اصطلاحات پیچیده و حرفه‌ای که ممکنه کاربر رو گیج کنه استفاده نکن، و اگر چیزی رو نمی‌دونی یا نیاز به اطلاعات بیشتر داری، صادقانه بگو یا سؤال بپرس تا بهتر راهنمایی کنی. تو فقط پاسخ نمی‌دی، بلکه همراه کاربر هستی تا قدم به قدم بتونه بهترین تصمیم‌ها رو برای آینده‌اش بگیره. همیشه خودت رو با عنوان «دستیار هوشمند یونی بست» معرفی کن و هیچ اسم دیگه‌ای نداشته باش. وظیفه تو ایجاد احساس امنیت، انگیزه و شفافیت در مسیر رشد فردیه. اگر کاربر درباره انتخاب رشته، بازار کار، دانشگاه، مسیر مهاجرت تحصیلی یا حتی سردرگمی‌های شخصی در مورد آینده‌ش سؤال داشت، باید دقیق، صمیمی و مسئولانه کمکش کنی. توسعه فردی هسته مرکزی تمام راهنمایی‌های توئه. ولی به طور مشخص نگو سوالی درباره مسیر شغلیت داری یا... بزار کاربر خودش بهت بگه تو اولین پیام ها.",
            },
            ...messages,
            { role: "user", content: userMessage },
          ],
          max_tokens: 2000,
        },
        {
          headers: {
            Authorization:
              "Bearer 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",
            "Content-Type": "application/json",
          },
        }
      );

      // پاسخ مدل رو دریافت کن
      const botMessage = response.data.choices[0].message.content;
      setMessages([
        ...messages,
        { role: "user", content: userMessage },
        { role: "assistant", content: botMessage },
      ]);
    } catch (error) {
      console.error("Error fetching data from OpenAI API:", error);
    }
    setLoading(false);
  };

  return (
    <div className="text-gray-200">
      <h1>پشتیبانی ChatGPT - myunibest.com</h1>

      <div>
        {messages.map((msg, index) => (
          <div
            key={index}
            className={
              msg.role === "user" ? "user-message" : "assistant-message"
            }
          >
            <strong>{msg.role === "user" ? "شما" : "دستیار"}: </strong>
            {msg.content}
          </div>
        ))}
      </div>

      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={input}
          onChange={handleChange}
          placeholder="سوالی دارید؟"
          disabled={loading}
          className="text-black"
        />
        <button type="submit" disabled={loading}>
          ارسال
        </button>
      </form>

      {loading && <p>در حال پردازش...</p>}
    </div>
  );
};

export default Design;
